module.exports = __webpack_public_path__ + "static/media/service14.66707f18.jpg";